import { useState, useCallback } from 'react';

export function useSelectionMode() {
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedIds, setSelectedIds] = useState(new Set());

  const enterSelection = useCallback(() => {
    setIsSelecting(true);
  }, []);

  const exitSelection = useCallback(() => {
    setSelectedIds(new Set());
    setIsSelecting(false);
  }, []);

  const toggleItem = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  return { isSelecting, selectedIds, enterSelection, exitSelection, toggleItem, clearSelection };
}
